import { Component, OnInit } from '@angular/core';
import { MsalService } from '@azure/msal-angular';
import { AccountInfo } from '@azure/msal-common';
import { RoleService } from '../shared/services/role.service';

@Component({
  selector: 'app-professional-services',
  templateUrl: './professional-services.component.html',
  styleUrls: ['./professional-services.component.scss']
})
export class ProfessionalServicesComponent implements OnInit {
  isSales: boolean;
  isSalesSupport: boolean;
  isDirector: boolean;
  isProjectManager: boolean;
  isAdmin: boolean;
  user: AccountInfo | null;
  isArchitectEngineer: boolean;
  isAvayaArchitectEngineer: boolean;
  isServicesOperations: boolean;
  constructor(
    private authService: MsalService,
    private roleService: RoleService) { }


  ngOnInit() {
    this.user = this.authService.instance.getActiveAccount();
    this.isProjectManager = false;
    this.isDirector = false;
    this.isAdmin = false;
    this.isProjectManager = false;
    this.isDirector = this.hasRole('PortalSEDirector') || this.hasRole('projects.approver');
    this.isSales = this.hasRole('PortalSEPostsalesEngineer');
    this.isSalesSupport = this.hasRole('PortalSalesSupport');
    this.isAdmin = this.hasRole('PortalAdmin');
    this.isArchitectEngineer = this.hasRole('PortalSEPresalesArchitect');
    if (this.hasRole('PortalSEProjectManager')) {
      this.isProjectManager = true;
    } if (this.hasRole('PortalSEProjectManagerOfficer')) {
      this.isProjectManager = true;
    }
    if (this.hasRole('PortalSEServiceOperations') || this.hasRole('ProfessionalServiceCoordinator')) {
      this.isServicesOperations = true;
    }
  }
  hasRole(role: string) {
    return this.roleService.checkRoleExists(role, this.user, false);
  }
  ngOnDestroy() {
  }

}
